import Button, * as Btn from '@lib/components/Button';
import CheckBox from '@lib/components/CheckBox';
import InputText, * as IInputText from '@lib/components/InputText';
import TitleBar, * as ITitleBar from '@lib/components/TitleBar';
import { ITranslationProps } from '@lib/i18n/translation';
import * as React from 'react';
import { IRecipient } from 'types';
import { IMAGE_PATH } from 'util/util';
import ErrorMessage from './ErrorMessage';
import './RecipientEdit.css';
import SuccessMessage from './SuccessMessage';


export interface IRecipientEditProps extends ITranslationProps {
  onValidateClick: (event: React.MouseEvent<HTMLDivElement>) => void;
  onChangeEmail: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeNumber: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onAlarmClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onNotifClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onTestClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
  errorMessage: string;
  isEmailError: boolean;
  isPhoneNumberError: boolean;
  successMessage: string;
  title: string;
  recipient: IRecipient;
  working: boolean;
}


/**
 * Component for title bar with a title and 1 or 2 button (left and right)
 */
class RecipientEdit extends React.Component<IRecipientEditProps, any> {

  public constructor(props: IRecipientEditProps) {
    super(props);
  }

  public componentDidMount() {
    // Waves.attach('div.button-large', 'waves-light');
  }

  public render() {

    const i18n = this.props.i18n;

    return (
      <div className="recipientEdit">
        <TitleBar
          leftIcon={ITitleBar.ICO_CHEVRON_LEFT}
          onLeftButtonClick={this.props.onValidateClick.bind(this, this.state)}
          title={this.props.title}
        />

        <div className="standardPage" style={{
          alignItems: 'center', display: "flex", flexDirection: "column",
          justifyContent: 'space-between'
        }}>
          <div>
            <img className="avatar" src={IMAGE_PATH + 'color3_100_user-circle@3x.png'} />
            <InputText icon={IInputText.ICO_ENVELOPE} maxLength={50} type="email" required={true} name={i18n.Common.email} id="email" isError={this.props.isEmailError} error={i18n.Common.errors.email} value={this.props.recipient.email} onChange={this.props.onChangeEmail} />
            <InputText icon={IInputText.ICO_PHONE} type="tel" required={true} name={i18n.Common.phone} id="phoneNumber" isError={this.props.isPhoneNumberError} value={this.props.recipient.phoneNumber} error={i18n.Common.errors.phoneNumber} onChange={this.props.onChangeNumber} />
            <div className="rowAlarmNotif">
              <div><CheckBox
                checked={this.props.recipient.inputAlarm} label={i18n.Media.alarm} onClick={this.props.onAlarmClick.bind(this, this.state)} />
              </div>
              <div><CheckBox
                checked={this.props.recipient.technicalAlarm} label={i18n.Media.notification} onClick={this.props.onNotifClick.bind(this, this.state)} />
              </div>
            </div>

          </div>
        </div>
        <div id="footerButton">
          <SuccessMessage message={i18n.Common.errors[this.props.successMessage]} />
          <ErrorMessage message={i18n.Common.errors[this.props.errorMessage]} />
          <Button disabled={this.props.working} label={i18n.RecipientList.test} type={Btn.BTN_TYPE_LARGE} onClick={this.props.onTestClick.bind(this, this.state)} />
        </div>
      </div>


    );
  }
}

export default RecipientEdit;


// WEBPACK FOOTER //
// ./src/components/RecipientEdit.tsx